var _defs, _path, _path2, _path3, _path4, _path5, _line, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:none;stroke:#4f4f4f;}.cls-1,.cls-3{stroke-linecap:round;}.cls-2{stroke-width:0.95px;}.cls-3{stroke-width:0.95px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10,14.94a15.69,15.69,0,0,1,2.18-4.73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.26,8.54A15.65,15.65,0,0,1,40.69,18.85a16.36,16.36,0,0,1-.12,2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10,15l.25,0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13.51,34.74A10.08,10.08,0,1,1,10,15"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.67,21a7.46,7.46,0,0,1,1.43-.14,7.12,7.12,0,0,1,0,14.24"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 42.98,
    y1: 35.08,
    x2: 36.22,
    y2: 35.08
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.7,30.45V18.65a2.84,2.84,0,0,0-2.83-2.84H22.13a2.84,2.84,0,0,0-2.83,2.84v11.8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.15,41.2l4.43-5.81c1.48-2,.23-4.94-2.07-4.94H16.45c-2.24,0-3.47,2.91-2,4.82l7.75,10.26a3.48,3.48,0,0,0,5.67,0l2.27-3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.0665c51e.svg";
export { ForwardRef as ReactComponent };